
















import {Vue, Component} from "vue-property-decorator";
import * as AtErrorEvent from "../modules/AtErrorEvent";
import {ForbiddenError, NotAuthenticated, ServiceUnavailable} from "../modules/PlayServerClient";
import rd from "@/modules/vRoutedefs";
import {nowPath} from "@/modules/utils";
import {ignoreRedundantNavErr, RouteLoadError} from "@/router";

@Component
export default class ErrorHandler extends Vue {
    defaultTitle = "Uhåndtert feil";
    opened = false;
    message = "";
    title = this.defaultTitle;
    pLoginButton = false;
    pReloadButton = false;

    get loginButton() {
        return this.pLoginButton;
    }
    set loginButton(v: boolean) {
        this.pLoginButton = v;
        if(v) {
            this.reloadButton = false;
        }
    }

    get reloadButton() {
        return this.pReloadButton;
    }
    set reloadButton(v: boolean) {
        this.pReloadButton = v;
        if(v) {
            this.loginButton = false;
        }
    }

    loginTo() {
        return {name: rd.public.name, query: {redir: nowPath()}};
    }

    gotoLogin() {
        ignoreRedundantNavErr(this.$router.push(this.loginTo()));
        this.opened = false;
    }

    reload() {
      const d = new Date();
      const cb = "cachebust=" + d.getTime();
      let s = window.location.search;
      if(s.length > 0) {
        window.location.search = s + "&" + cb;
      } else {
        window.location.search = "?" + cb;
      }
    }

    handleError(e: Error) {
        if(e instanceof ForbiddenError) {
            this.title = "Manglende rettighet";
            this.message = "Forespørsel blokkert pga manglende rettighet. Du må tildeles brukerrolle med mer rettigheter for å få utført denne operasjonen.";
        } else if(e instanceof NotAuthenticated) {
            this.title = "Ikke innlogget";
            this.message = "Du må logge inn på nytt";
            this.loginButton = true;

        } else if(e instanceof RouteLoadError) {
          this.title = "Innlasting feilet";
          this.message = "Innlasting av sidekomponent feilet. Last siden på nytt og prøv igjen";
          console.error(`RouteLoadError:`, e);
          this.reloadButton = true;

        } else if(e instanceof ServiceUnavailable) {
          this.title = "Tjeneste utilgjengelig";
          this.message = e.message;
          console.error(`ServiceUnavailable:`, e);
          this.reloadButton = true;

        } else {
            const err = e as Error;
            this.title = this.defaultTitle;
            this.message = err.message;
        }
        this.opened = true;
    }

    // hooks
    created() {
        // add error listener
        window.addEventListener("error", (e: ErrorEvent) => {
            if(e.error) {
                this.handleError(e.error);
            } else {
                this.handleError(new Error(e.message));
            }
        });
        window.addEventListener("unhandledrejection", (e: PromiseRejectionEvent) => {
            if(e.reason) {
                throw e.reason;
            } else {
                throw e;
            }
        });
        window.addEventListener(AtErrorEvent.name, (e: Event) => {
            console.warn("unhandled rejection", e);
            if(e instanceof CustomEvent) {
                this.handleError(e.detail);
            } else {
                throw `Unexpected event: ${e}`;
            }
        });
        Vue.config.errorHandler = (error: Error) => {
            console.debug("Rethrow error so normal handler catches it", error);
            if(error instanceof Error) {
                this.handleError(error);
            } else {
                this.handleError(new Error(error));
            }
        }
    }
}
